import React from 'react';
import { Radar } from 'react-chartjs-2';
import './chartSetup';
import { useThemeMode } from '../theme';
import { buildRadar } from './builders';
import { themePalette } from './palette';

// Radar chart. `data` from charts.prepareCategories [{ label, value }].
export default function RadarViz({ data }) {
  useThemeMode();
  const { data: chartData, options } = buildRadar(data, themePalette());
  return <Radar data={chartData} options={options} />;
}
